import {
  CheckCheck,
  CheckCircle,
  ClipboardCheck,
  Clock,
  CreditCard,
  Loader,
  ShieldX,
  TrendingDown,
  TrendingUp,
} from 'lucide-react';
import i18n from '../i18n';

export const types = {
  enroll: i18n.t('enroll'),
  sitevisit: i18n.t('site_visit'),
  online: i18n.t('online'),
  offline: i18n.t('offline'),
  wallet: i18n.t('wallet'),
};

export const DeliveryStatus = {
  pending: 1,
  approved: 2,
  rejected: 3,
  fundAdded: 4,
  fundDeduct: 5,
  financeSettled: 6,
  loadingStarted: 7,
  loadingCompleted: 8,
  completed: 9,
};

export const DELIVERY_STATUS = {
  1: 'Pending',
  2: 'Approved',
  3: 'Rejected',
  4: 'Fund Added',
  5: 'Fund Deducted',
  6: 'Finance Settled',
  7: 'Loading Started',
  8: 'Loading Completed',
  9: 'Completed',
};

export const DELIVERY_STATUS_ICONS = {
  1: Clock, // Pending
  2: CheckCircle, // Approved
  3: ShieldX, // Rejected
  4: TrendingUp, // Fund Added
  5: TrendingDown, //Fund Deducted
  6: CreditCard, //Finance Settle
  7: Loader, //Loading Started
  8: CheckCheck, //Loadting Completed
  9: ClipboardCheck, //Project Completed
};

export const CLIENT_APPROVAL = {
  1: 'Pending',
  2: 'Approved',
  3: 'Rejected',
  4: 'Approved',
  5: 'Approved',
  6: 'Approved',
  7: 'Loading Started',
  8: 'Loading Completed',
  9: 'Completed',
};

export const AUCTION_STATUS = {
  N: 'Pending',
  A: 'Active',
  E: 'Expired',
};
export const AUCTION_APPROVE_STATUS = {
  NU: 'Pending',
  A: 'Approved',
  R: 'Rejected',
};

export const CLIENT_PAYMENT_TYPE = {
  bidder: 'From Bidder',
  add_fund: 'Fund Added By PM',
  wallet_swap: 'Wallet Swap',
};

export const BADGE_COLORS = {
  // Pending - amber/yellow
  Approved: '#3B82F6', // Approved - blue
  Rejected: '#EF4444', // Rejected - red
  'Fund Added': '#10B981', // Fund Added - green
  'Fund Deducted': '#F97316', // Fund Deducted - orange
  'Finance Settled': '#14B8A6', // Finance Settled - teal
  'Loading Started': '#6366F1', // Loading Started - indigo
  'Loading Completed': '#8B5CF6', // Loading Completed - purple
  Completed: '#22C55E', // Completed - bright green
  'Bidder Fund Added': '#F97316', // Fund added - orange
  'FS Approved': '#14B8A6', // Finance Support Approved - teal
  'FM Approved': '#22C55E', // Finance Admin Approved- bright green,
  'FS Rejected': '#EF4444',
  'FM Rejected': '#EF4444',
  Active: '#22C55E',
  Expired: '#EF4444',
  'قيد الانتظار': '#FBBF24',
  نشط: '#22C55E',
  منتهي: '#EF4444',
};

export const WALLET_STATUS = {
  pending: 'F',
  approved: 'A',
  Rrejected: 'rejected',
};

export const TEST_WALLET_STATUS = {
  pending: 'B',
  approved: 'FS',
  completed: 'FA',
  rejected: 'MR',
};

export const DELIVERY_STATUS_REVERSE = {
  pending: 1,
  approved: 2,
  rejected: 3,
  fundAdded: 4,
  fundDeducted: 5,
  financeSettled: 6,
  LoadingStarted: 7,
  LoadingCompleted: 8,
  Completed: 9,
};

export const TRANSACTION_STATUS = {
  B: 'Bidder Fund Added',
  FS: 'FS Approved',
  FA: 'FM Approved',
  SR: 'FS Rejected',
  MR: 'FM Rejected',
};
